import { render, staticRenderFns } from "./reviewer-inactive-list.component.vue?vue&type=template&id=3026ff7b&"
import script from "./reviewer-inactive-list.component.ts?vue&type=script&lang=ts&"
export * from "./reviewer-inactive-list.component.ts?vue&type=script&lang=ts&"
import style0 from "./reviewer-inactive-list.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports